import React from 'react';
import '../styles/layout/comingSoon.scss';

const ComingSoon = ({ featureName }) => {
  return (
    <div className="coming-soon-container">
      <div className="coming-soon-content">
        <h2>{featureName}</h2>
        <p>This new feature is coming soon to VisionTrak. Stay tuned!</p>
      </div>
    </div>
  );
};

export default ComingSoon; 